import React from "react";
import PropTypes from "prop-types";

const AlertCircleIcon = ({
  width,
  height,
  color,
  strokeWidth,
  className,
  ...props
}) => (
  <svg
    width={width || 38}
    height={height || 38}
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <circle
      cx="18.6667"
      cy="18.6667"
      r="15.5556"
      stroke={color}
      strokeWidth={strokeWidth}
    />
    <path
      d="M18.6542 23.3333H18.6682"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.6667 18.6667L18.6667 12.4444"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

AlertCircleIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

AlertCircleIcon.defaultProps = {
  width: undefined,
  height: undefined,
  color: "currentColor",
  strokeWidth: 3.11111,
  className: "",
};

export default AlertCircleIcon;
